/**
 * GB:
 *
 * This must mirror the corresponding C# enum.
 * See further notes in the C# file NotificationType.cs
 */

export enum NotificationType {

    MatchReportPending = 1,
    MatchReportRunning,
    MatchReportCaching,
    MatchReportComplete,
    MatchReportError,

    MobilyticsReportPending,
    MobilyticsReportRunning,
    MobilyticsReportCaching,
    MobilyticsReportComplete,
    MobilyticsReportError,
}